import api from "./api";
import StorageService from "./StorageService";

const ProjectLocationService = {
  getAll: async (page = 1, limit = 20, employeeId = null, roleId = null, companyId = null) => {
    try {
      const login = StorageService.loginData();
      const activeCompany = StorageService.activeCompany();
      const res = await api.get("/projectLocations/getAll",{
         params: {
         page,
         limit,
         employeeId: employeeId || login?.employeeId,
         roleId: roleId || login?.roleId,
         companyId: companyId || activeCompany?.companyId,
       },
      });
      return res.data;
    } catch (err) {
      console.error("Error fetching project locations:", err);
      throw err;
    }
  },

  create: async (payload) => {
    try {
      const res = await api.post("/projectLocations/save", payload);
      return res.data;
    } catch (err) {
      console.error("Error creating project location:", err);
      throw err;
    }
  },

  update: async (id, payload) => {
    try {
      const res = await api.put(`/projectLocations/${id}`, payload);
      return res.data;
    } catch (err) {
      console.error("Error updating project location:", err);
      throw err;
    }
  },

  remove: async (id) => {
    try {
      const res = await api.delete(`/projectLocations/${id}`);
      return res.data;
    } catch (err) {
      console.error("Error deleting project location:", err);
      throw err;
    }
  },

  updateStatus: async (id) => {
    const res = await api.put(`/projectLocations/updatestatus/${id}`);
    return res.data;
  },

  getByProjectId: async (projectId) => {
    try {
      const res = await api.get(`/projectLocations/getByProjectId/${projectId}`);
      return res.data;
    } catch (err) {
      console.error("Error fetching project locations by project:", err);
      throw err;
    }
  },

  getByProjectAndStore: async (projectId, storeId) => {
  try {
    const res = await api.get(
      `/projectLocations/getByProjectStore/${projectId}/${storeId}`
    );
    return res.data;
  } catch (err) {
    console.error("Error fetching project locations by project & store:", err);
    throw err;
  }
},

  getActiveLocationsForDPR: async (projectId) => {
    try {
      const res = await api.get(
        `/projectLocations/activeLocationsForDPR/${projectId}`
      );
      return res.data;
    } catch (err) {
      console.error("Error fetching DPR locations:", err);
      throw err;
    }
  },

  
};

export default ProjectLocationService;
